var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 23.5C18.5388 23.5 23.6875 18.3513 23.6875 12C23.6875 5.64873 18.5388 0.5 12.1875 0.5C5.83623 0.5 0.6875 5.64873 0.6875 12C0.6875 18.3513 5.83623 23.5 12.1875 23.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 23C18.2626 23 23.1875 18.0751 23.1875 12C23.1875 5.92487 18.2626 1 12.1875 1C6.11237 1 1.1875 5.92487 1.1875 12C1.1875 18.0751 6.11237 23 12.1875 23Z",
    stroke: "#1A1C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0184 13.3877L13.9075 14.256L16.0351 16.9782L17.146 16.1099L15.0184 13.3877Z",
    fill: "#1A1C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4614 17.425L13.3344 14.705C12.3925 14.4431 11.5593 13.8861 10.9572 13.1157C10.3552 12.3454 10.016 11.4023 9.98945 10.4249L7.86245 7.70295C7.86245 7.70295 5.84545 10.591 9.00845 14.636C12.1714 18.681 15.4614 17.425 15.4614 17.425Z",
    fill: "#1A1C2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54844 6.38867L8.4375 7.25695L10.5651 9.97916L11.676 9.11088L9.54844 6.38867Z",
    fill: "#1A1C2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0.6875 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbPhone);
export default __webpack_public_path__ + "static/media/bb-phone.6fc194c6b8870b3a591e282fa00992e1.svg";
export { ForwardRef as ReactComponent };